import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDonorLeaderboard } from "apis/DonorServiceApi";
import { setDonorLeaderboard } from "./campaignLeaderDonors.slice";

export const fetchDonorLeaderboard = createAsyncThunk(
  "campaigns/donorLeaderboard/fetch",
  async (campaign_id: string, { dispatch, rejectWithValue }) => {
    try {
      const response = await getDonorLeaderboard({ campaign_id });

      if (Array.isArray(response)) {
        dispatch(setDonorLeaderboard(response));
      } else {
        return rejectWithValue("Invalid donor leaderboard response format");
      }
    } catch (error) {
      const err = error as { response?: { data?: { error?: string } } };
      rejectWithValue(
        err.response?.data?.error || "Failed to fetch campaign donors"
      );
    }
  }
);
